<app-header-fabricator-rewards
        [titulo]="'We Rewards'"
        [textoSecundario]="'weupgrade'"
        [urlImagenHeader]="'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/beneficios.png'">
</app-header-fabricator-rewards>


<app-information-fabricator-rewards></app-information-fabricator-rewards>


<app-footer-fabricator-rewards
        [comentario]="comentario"
        [valoracion]="valoracion"
        [telefono]="telefono"
        [email]="email"
        (comentarioChange)="comentario = $event"
        (valoracionChange)="valoracion = $event">
</app-footer-fabricator-rewards>